import { AfterViewInit, Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { AccessService } from 'app/core/services/access.service';

@Component({
  selector: 'dialog-view-departments',
  templateUrl: './dialog-view-departments.component.html',
  styleUrls: ['./dialog-view-departments.component.scss']
})
export class DialogViewDepartmentsComponent implements OnInit, AfterViewInit {

  isLoading: boolean = false;
  displayedColumns: string[] = ['number', 'department', 'action'];
  dataSource = new MatTableDataSource<any>([]);

  @ViewChild('paginator1') paginator1: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  dataSource2 = new MatTableDataSource<any>([]);

  @ViewChild('paginator2') paginator2: MatPaginator;
  @ViewChild(MatSort) sort2: MatSort;

  dataSource3 = new MatTableDataSource<any>([]);

  @ViewChild('paginator1') paginator3: MatPaginator;
  @ViewChild(MatSort) sort3: MatSort;

  loading: boolean[] = [];

  constructor(public dialogRef: MatDialogRef<DialogViewDepartmentsComponent>, @Inject(MAT_DIALOG_DATA) public data: any,
    private accessService: AccessService) { }

  ngOnInit(): void {
    this.getDepartments();
    this.getBranches();
    this.getClients();
  }

  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator1;
    this.dataSource.sort = this.sort;

    this.dataSource2.paginator = this.paginator2;
    this.dataSource2.sort = this.sort2;

    this.dataSource3.paginator = this.paginator3;
    this.dataSource3.sort = this.sort3;
  }

  getDepartments() {
    this.isLoading = true;
    this.accessService.getDepartments(this.data.id).subscribe({
      next: res => {
        this.isLoading = false;
        this.dataSource.data = res;
      },
      error: err => {
        this.isLoading = false;
        console.log(err);
      }
    })
  }

  getBranches() {
    this.isLoading = true;
    this.accessService.getBranches(this.data.id).subscribe({
      next: res => {
        this.isLoading = false;
        this.dataSource2.data = res;
      },
      error: err => {
        this.isLoading = false;
        console.log(err);
      }
    })
  }

  getClients() {
    this.isLoading = true;
    this.accessService.getClients(this.data.id).subscribe({
      next: res => {
        this.isLoading = false;
        this.dataSource3.data = res;
      },
      error: err => {
        this.isLoading = false;
        console.log(err);
      }
    })
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  deleteDepartment(id: number, index: number) {
    this.loading[index] = true;
    this.accessService.deleteDepartment(id).subscribe({
      next: (res) => {
        const data = this.dataSource.data;
        data.splice(index, 1);
        this.dataSource.data = [...data];
        this.loading[index] = false;
      },
      error: (err) => {
        console.error(err);
        this.loading[index] = false;
      }
    });
  }

  deleteBranch(id: number, index: number) {
    this.loading[index] = true;
    this.accessService.deleteBranch(id).subscribe({
      next: (res) => {
        const data = this.dataSource2.data;
        data.splice(index, 1);
        this.dataSource2.data = [...data];
        this.loading[index] = false;
      },
      error: (err) => {
        console.error(err);
        this.loading[index] = false;
      }
    });
  }

  deleteClient(id: number, index: number) {
    this.loading[index] = true;
    this.accessService.deleteClient(id).subscribe({
      next: (res) => {
        const data = this.dataSource3.data;
        data.splice(index, 1);
        this.dataSource3.data = [...data];
        this.loading[index] = false;
      },
      error: (err) => {
        console.error(err);
        this.loading[index] = false;
      }
    });
  }
}
